import LoaderMain from './LoaderMain';

const Loader = LoaderMain;

export { Loader };
